module.exports = __webpack_public_path__ + "img/Delfina-Jackson.88d80f26.jpg";